import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";
const data = [
    {
        icon: <HiShieldCheck />,
        heading: "Best interest rates on the market",
        detail:
            "Find the best interest rates on the market with our real estate platform. We offer up-to-date mortgage rates from top lenders to help you secure the most competitive deals for your dream home.",
    },
    {
        icon: <MdCancel />,
        heading: "Prevent unstable prices",
        detail:
            "Prevent unstable prices with our real estate platform. We provide accurate market data and insights to help you make informed decisions, ensuring you get the best value for your investment.",
    },
    {
        icon: <MdAnalytics />,
        heading: "Best price on the market",
        detail:
            "Get the best price on the market with our real estate platform. We offer comprehensive listings and detailed comparisons to ensure you find the most competitive deals for your property needs.",
    },
];
export default data;